import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClassAbstractDark = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12.9497 3.05025C15.6834 5.78392 15.6834 10.2161 12.9497 12.9497C10.216 15.6834 5.78388 15.6834 3.05021 12.9497C0.316541 10.2161 0.316541 5.78392 3.05021 3.05025C5.78388 0.316583 10.216 0.316583 12.9497 3.05025Z",
			fill: "#25324D"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.9143 6.90481L13.9264 7.06045C13.7359 5.85124 13.1755 4.69027 12.2426 3.75736C11.3097 2.82445 10.1487 2.26404 8.93951 2.07352L9.09515 1.0857C10.5062 1.30802 11.8623 1.96287 12.9497 3.05025C14.0371 4.13763 14.6919 5.49375 14.9143 6.90481ZM6.90477 1.0857L7.06041 2.07352C5.8512 2.26404 4.69023 2.82445 3.75732 3.75736C2.82441 4.69027 2.26399 5.85124 2.07348 7.06045L1.08566 6.90481C1.30798 5.49375 1.96283 4.13763 3.05021 3.05025C4.13759 1.96287 5.49371 1.30802 6.90477 1.0857ZM1.08566 9.09519C1.30798 10.5063 1.96283 11.8624 3.05021 12.9497C4.13759 14.0371 5.49371 14.692 6.90477 14.9143L7.0604 13.9265C5.8512 13.736 4.69023 13.1755 3.75732 12.2426C2.82441 11.3097 2.26399 10.1488 2.07348 8.93955L1.08566 9.09519ZM9.09515 14.9143L8.93951 13.9265C10.1487 13.736 11.3097 13.1755 12.2426 12.2426C13.1755 11.3097 13.7359 10.1488 13.9264 8.93955L14.9143 9.09519C14.6919 10.5063 14.0371 11.8624 12.9497 12.9497C11.8623 14.0371 10.5062 14.692 9.09515 14.9143Z",
			fill: "#548AF7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.13295 11.5C9.61223 11.5 10.8836 10.6105 11.2075 9.33909H10.2213C9.90229 10.0739 9.11914 10.6057 8.13295 10.6057C6.77936 10.6057 5.80284 9.51796 5.80284 8C5.80284 6.48204 6.77936 5.39434 8.13295 5.39434C9.11914 5.39434 9.90229 5.92611 10.2213 6.66091H11.2075C10.8836 5.3895 9.61223 4.5 8.13295 4.5C6.21859 4.5 4.79248 5.99378 4.79248 8C4.79248 10.0062 6.21859 11.5 8.13295 11.5Z",
			fill: "#548AF7"
		})
	]
});
export default SvgClassAbstractDark;
